import { loadAndTrack } from "redux-request-loading";

import { Dispatch } from "../store";

import { createOhCaseSuccess } from "../crud/ohCase/actions";

import { CREATE_GENERIC_CASE } from "./actionTypes";
import { genericCaseApi } from "./genericCaseApi";

export const createGenericCase = (customerId: string, employeeRecordId: string, genericCaseTypeId: string) =>
    async (dispatch: Dispatch) => {
        const createdOhCase = await loadAndTrack(dispatch, CREATE_GENERIC_CASE, genericCaseApi.create(customerId, employeeRecordId, genericCaseTypeId));
        dispatch(createOhCaseSuccess(createdOhCase));
        return createdOhCase;
    };
